<template>
  <div class="pravo">
    <div class="game-controls">
      <Time v-on:timeFinished="$emit('next-round')" />
      <Rounds />
    </div>

    <PravoTop Image="gameOverview" :Header="this.gameName" />

    <div class="pravo__obsah">
      <div class="pravo__buttons">
        <GoBack
          href="/gameManager/allGames"
          icon="gameOverview"
          text="Back to all games"
        />

        <GoBack
          href="/gameManager/game/settings"
          icon="gameSettings"
          additionalClass="additionalButton"
          text="Back to game settings"
          v-if="!this.archived"
        />

        <button
          class="pravo__buttons__goBack downloadCsv"
          @click="downloadGameOwnerData(activeGame.id)"
        >
          Download .csv
        </button>
      </div>

      <div class="grid">
        <TeamRanking TableWidth="half" />

        <FinancialOverviewTeams
          v-for="team in financialOverview"
          :key="team.id"
          TableWidth="half"
          :teamName="team.name"
          :teamMoney="team.results[team.results.length - 1].metric"
          :sourceData="team.results"
          :teamId="team.id"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import PravoTop from "@/components/game/pravo/PravoTop.vue";
import TeamRanking from "@/components/game/table/tables/TeamRanking.vue";
import FinancialOverviewTeams from "@/components/gameManager/FinancialOverviewTeams.vue";
import GoBack from "@/components/game/pravo/GoBack.vue";
import Rounds from "@/components/game/controls/Rounds.vue";
import Time from "@/components/game/controls/Time.vue";

export default {
  name: "gameOverviewManager",
  components: {
    PravoTop,
    TeamRanking,
    FinancialOverviewTeams,
    GoBack,
    Rounds,
    Time,
  },
  data: function () {
    return {
      gameName: "Game overview",
      archived: false,
    };
  },
  computed: {
    ...mapGetters(["financialOverview", "activeGame", "ownerCurrentGame"]),
  },
  methods: {
    ...mapActions({ downloadGameOwnerData: "downloadGameOwnerData" }),
    isArchived() {
      if (this.activeGame.endedTime != null) {
        this.archived = true;
      } else {
        this.archived = false;
      }
    },
  },
  mounted() {
    if (this.activeGame != null) {
      this.gameName = "Game overview - " + this.activeGame.name;
      this.isArchived();
    }
  },
};
</script>

<style>
</style>
